import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import CloseIcon from 'react-icons/lib/fa/close';
import LeftIcon from 'react-icons/lib/fa/angle-left';
import RightIcon from 'react-icons/lib/fa/angle-right';
import Slider from 'react-slick';
import { withTranslation } from 'react-i18next';

import { Button } from '../shared/Button'
import { colors, fonts, textStyles } from '../../shared/styles';
import { configs } from '../../configs';
import { inIframe } from '../../utils/inIframe';
import { query } from '../../utils/auth';
import { trackGoogleEvent } from '../../utils/googleEvents';

class LogInOrSignUpIndependentComponent extends Component {
  static propTypes = {
    t: PropTypes.func
  };

  handleRequestClose = () => {
    this.props.closeAction()
  }

  handleRequestSignIn = () => {
    this.handleRequestClose();

    if (inIframe()) {
      window.open(`${configs.bragiUrl}/signin?${query()}`, 'signin');
    }
    else {
      document.location.href = `${configs.bragiUrl}/signin`;
    }

    trackGoogleEvent('Authentication', 'Click', 'Modal Sign In');
  }

  handleRequestSignUp = () => {
    this.handleRequestClose();

    if (inIframe()) {
      window.open(`${configs.bragiUrl}/signup?${query()}`, 'signup');
    }
    else {
      document.location.href = `${configs.bragiUrl}/signup`;
    }

    trackGoogleEvent('Authentication', 'Click', 'Modal Sign Up');
  }

  render() {
    const {
      isMobile,
      t
    } = this.props;


    const styles = {
      container: {
        height: isMobile ? document.documentElement.clientHeight : 588,
        minHeight: isMobile ? document.documentElement.clientHeight : 588,
        width: isMobile ? document.documentElement.clientWidth : 717,
        minWidth: isMobile ? document.documentElement.clientWidth : 717,
        padding: 0,
        backgroundColor: '#141723',
        overflow: 'hidden',
      },
      leftStyle: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 10,
        left: -14,
      },
      rightStyle: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 10,
        right: -14,
      },
      labelStyle: {
        textTransform: 'capitalize',
        fontSize: 16,
        fontFamily: 'ProximaNovaRegular'
      },
      actionsStyle: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        [isMobile?'bottom':'top']: isMobile ? 32 : 528,
        whiteSpace: 'nowrap'
      },
      titleText: {
        position: 'relative',
        textAlign: 'center',
        ...textStyles.sectionHead,
        fontSize: 18,
        color: '#16A9E1',
        fontStyle: 'italic',
        fontWeight: 'bold',
        lineHeight: '22px',
        top: isMobile ? 32 : 10,
      },
      subTitleText: {
        ...textStyles.sectionHead,
        ...fonts.boldItalic,
        fontSize: '38px',
        color: '#FFFFFF',
        letterSpacing: -0.5,
        textAlign: 'center',
        lineHeight: '36px',
        position: 'relative',
        top: isMobile ? 32 : 10,
      },
      signInButton: {
        ...textStyles.sectionHead,
        backgroundColor: 'rgba(255,255,255,0)',
        border: '1px solid #F1F1F1',
        color: '#F1F1F1',
        fontSize: 14,
        fontWeight: 'bold',
        height: 41,
        margin: '0px 10px',
        minWidth: Math.min(183, document.documentElement.clientWidth / 2 - 64),
        textAlign: 'center',
        textTransform: 'uppercase',
      },
      signUpButton: {
        ...textStyles.sectionHead,
        backgroundColor: colors.blue,
        border: '1px solid ' + colors.blue,
        color: '#fff',
        fontSize: 14,
        fontWeight: 'bold',
        height: 41,
        margin: '0px 10px',
        minWidth: Math.min(183, document.documentElement.clientWidth / 2 - 64),
        textAlign: 'center',
        textTransform: 'uppercase',
      }
    }

    // console.log(styles)

    const arrowClassName = isMobile ?
      'LogInOrSignUpIndependent-navbutton-mobile' :
      'LogInOrSignUpIndependent-navbutton'

    const LeftArrow = ({currentSlide, slideCount, ...props}) =>
      <div style={styles.leftStyle} className={arrowClassName}>
        <LeftIcon {...props} size={78}
        style={{display: currentSlide === 0 ? 'none' : 'block'}}/>
      </div>;

    const RightArrow = ({currentSlide, slideCount, ...props}) =>
      <div style={styles.rightStyle} className={arrowClassName}>
        <RightIcon {...props} size={78}
          style={{display: currentSlide === slideCount - 1 ? 'none' : 'block'}}/>
      </div>;

    const settings = {
      dots: true,
      dotsClass: 'LogInOrSignUpIndependent-slick-dots',
      infinite: false,
      speed: 500,
      arrows: true,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />,
      swipe: isMobile,
      // responsive: [
      //   {
      //     breakpoint: 320,
      //     settings: {
      //       arrows: true,
      //       dots: false
      //     }
      //   }]
    };

    const signUpModal = [
      {
        titleText: t('Finisher Certificates'),
        subTitleText: t('Claim your race results'),
        img: `${configs.cdnUrl}/images/sign-up1.png`
      },
      {
        titleText: t('Rivals'),
        subTitleText: t('Compete with friends'),
        img: `${configs.cdnUrl}/images/sign-up2.png`
      },
      {
        titleText: t('Start Lists'),
        subTitleText: t('View the official roster'),
        img: `${configs.cdnUrl}/images/sign-up3.png`
      }
    ];

    const standardActions = (
      <div style={styles.actionsStyle}>
        <Button
          id='sign-in-modal-button'
          onClick={this.handleRequestSignIn}
          style={styles.signInButton}
          text={'Sign In'}
        />
        <Button
          id='join-modal-button'
          onClick={this.handleRequestSignUp}
          style={styles.signUpButton}
          text={'Join'}
        />
      </div>
    )

    const body = (
      <div style={{...styles.container}}>
        <Slider {...settings} style={styles.container}>
          {
            signUpModal.map(({titleText, img, subTitleText}, index) => {
              return <div key={index} style={{
                ...styles.container,
                backgroundImage: `url(${img})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
              }}>
                <div style={styles.titleText}>
                  {titleText}
                </div>
                <div style={styles.subTitleText}>
                  {subTitleText}
                </div>
              </div>
            })
          }
        </Slider>
        {standardActions}
        <div style={{
          position: 'absolute',
          top: 10,
          right: 10,
          cursor: 'pointer',
        }}
        className='LogInOrSignUpIndependent-navbutton'
        onClick={this.handleRequestClose}>
          <CloseIcon size={24} />
        </div>
      </div>
    );

    return (
      <Dialog
        fullScreen={isMobile}
        maxWidth={false}
        onClose={this.handleRequestClose}
        open={this.props.open}
      >
        {body}
      </Dialog>
    );
  }
}

export const LogInOrSignUpIndependent = withTranslation()(LogInOrSignUpIndependentComponent);



/** WEBPACK FOOTER **
 ** ./components/modal/LogInOrSignUpIndependent.js
 **/